import React from 'react';

export function Pencil() {
  return (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.6805 8.95703L4.8623 36.7752L9.26404 41.4215L36.8952 13.7903C37.0004 13.6851 37.112 13.59 37.2286 13.5052L32.6805 8.95703ZM18.8898 51.5819L13.0918 45.4619L40.8293 17.7244L40.9279 17.6206C40.9948 17.5466 41.0569 17.47 41.1144 17.3909L47.1197 23.3963C47.003 23.4811 46.8915 23.5762 46.7863 23.6814L18.9681 51.4995L18.8898 51.5819ZM22.7071 55.6113L27.1168 60.2661L55.5532 31.8297L51.0054 27.282C50.948 27.361 50.8858 27.4377 50.819 27.5117L50.7203 27.6155L22.9022 55.4336C22.8393 55.4965 22.7742 55.5557 22.7071 55.6113Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.6807 8.95739L55.5534 31.8301L61.7443 25.6392C64.6412 22.7422 64.6412 18.0453 61.7443 15.1483L49.3625 2.76648C46.4655 -0.130493 41.7686 -0.130495 38.8716 2.76648L32.6807 8.95739Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.86242 36.7754L1.62152 40.0163C0.925934 40.7119 0.535156 41.6553 0.535156 42.639V60.8845C0.535156 62.9329 2.19577 64.5935 4.24424 64.5935H21.2533C22.237 64.5935 23.1805 64.2028 23.876 63.5072L27.1169 60.2663L4.86242 36.7754Z"
        fill="currentColor"
      />
    </svg>
  );
}
